module.exports = "<div class='pagination'\n    *ngIf='hasHits'>\n  <app-tag-page *ngFor='let i of startPageRecords'\n      [start]='i'>\n  </app-tag-page>\n</div>\n\n<div *ngIf='!hasHits && showNoHit'\n    class='noHit'>\n  NO HIT\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/pages-box/pages-box.component.html
// module id = ../../../../../src/app/pages-box/pages-box.component.html
// module chunks = main